module.exports = __webpack_public_path__ + "ui-static/img/cameras-no-items_dark.daee35ac.svg";